import styled, { css, keyframes } from 'styled-components';
import { SliderSpinner } from "./SliderSpinner.js";
var rotateKeyframes = /*#__PURE__*/keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var getBackgroundColor = function getBackgroundColor(_ref) {
  var theme = _ref.theme,
    $variant = _ref.$variant,
    $disabled = _ref.$disabled;
  var backgroundColors = {
    default: {
      normal: theme.kallisto.color.background.interactive.backgroundTertiaryDefault,
      disabled: theme.kallisto.color.background.static.backgroundDisabled
    },
    white: {
      normal: theme.kallisto.color.common.white[1000],
      disabled: theme.kallisto.color.common.white[1000]
    }
  };
  return backgroundColors[$variant][$disabled ? 'disabled' : 'normal'];
};
var getBorderColor = function getBorderColor(_ref2) {
  var theme = _ref2.theme,
    $variant = _ref2.$variant,
    $disabled = _ref2.$disabled;
  var borderColors = {
    default: {
      normal: 'transparent',
      disabled: 'transparent'
    },
    white: {
      normal: theme.kallisto.color.border.static.borderNeutral,
      disabled: theme.kallisto.color.border.static.borderDisabled
    }
  };
  return borderColors[$variant][$disabled ? 'disabled' : 'normal'];
};
var SwitchWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Switchstyles__SwitchWrapper",
  componentId: "sc-1ym8u79-0"
})(["position:relative;flex-shrink:0;height:", ";width:", ";display:flex;align-items:center;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.kallisto.space.space250;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.kallisto.space.space500;
});
var Switch = /*#__PURE__*/styled.div.withConfig({
  displayName: "Switchstyles__Switch",
  componentId: "sc-1ym8u79-1"
})(["position:absolute;height:", ";width:", ";transition:all 200ms;background:", ";border:1px solid ", ";border-radius:1em;box-sizing:border-box;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.kallisto.space.space250;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.kallisto.space.space500;
}, getBackgroundColor, getBorderColor);
var SliderSpinnerStyled = /*#__PURE__*/styled(SliderSpinner).withConfig({
  displayName: "Switchstyles__SliderSpinnerStyled",
  componentId: "sc-1ym8u79-2"
})(["position:absolute;animation:", " 0.7s linear infinite;transition:opacity 100ms ease-in-out;"], rotateKeyframes);
var Slider = /*#__PURE__*/styled.div.withConfig({
  displayName: "Switchstyles__Slider",
  componentId: "sc-1ym8u79-3"
})(["height:", ";width:", ";border-radius:1em;background:", ";border:", ";box-sizing:border-box;transition:all 200ms;display:flex;align-items:center;justify-content:center;position:relative;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.kallisto.space.space200;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.kallisto.space.space200;
}, function (_ref9) {
  var theme = _ref9.theme,
    $disabled = _ref9.$disabled;
  return $disabled ? theme.kallisto.color.icon.static.iconDisabled : theme.kallisto.color.icon.static.iconInverse;
}, function (_ref0) {
  var theme = _ref0.theme,
    $variant = _ref0.$variant;
  return $variant === 'white' ? "1px solid ".concat(theme.kallisto.color.border.static.borderNeutral) : 'none';
});
var Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "Switchstyles__Input",
  componentId: "sc-1ym8u79-4"
})(["position:absolute;opacity:0;&:focus-visible{& ~ ", "{outline:2px ", " solid;outline-offset:0;box-shadow:0 0 0 4px ", ";}}"], Switch, function (_ref1) {
  var theme = _ref1.theme;
  return theme.kallisto.color.common.white[1000];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.kallisto.color.common.black[1000];
});
var Wrapper = /*#__PURE__*/styled.label.withConfig({
  displayName: "Switchstyles__Wrapper",
  componentId: "sc-1ym8u79-5"
})(["", ""], function (_ref11) {
  var theme = _ref11.theme,
    $variant = _ref11.$variant,
    $disabled = _ref11.$disabled,
    $isLoading = _ref11.$isLoading,
    $ltr = _ref11.$ltr;
  return css(["", ";display:inline-flex;align-items:center;flex-direction:", ";", " & ", "{& ~ ", "{transform:translate3d(2px,0,0);}}& ", ":checked{& ~ ", "{transform:translate3d(22px,0,0);}& ~ ", "{background-color:", ";border-color:transparent;}}"], $disabled || $isLoading ? 'pointer-events: none' : 'cursor: pointer', $ltr ? 'row-reverse' : 'row', !$isLoading ? css(["&:hover{& ", ":checked{& ~ ", "{background:", ";}}& ", ":not(:checked){& ~ ", "{", ";", ";}}}&:active{& ", ":checked{& ~ ", "{background:", ";}& ~ ", "{width:", ";transform:translate3d(18px,0,0);}}& ", ":not(:checked){& ~ ", "{", ";", ";}& ~ ", "{width:", ";}}}"], Input, Switch, theme.kallisto.color.background.interactive.backgroundBrandContrastHover, Input, Switch, $variant === 'default' ? css(["background-color:", ";"], theme.kallisto.color.background.interactive.backgroundTertiaryHover) : '', $variant === 'white' ? css(["border-color:", ";"], theme.kallisto.color.border.interactive.borderNeutralHover) : '', Input, Switch, theme.kallisto.color.background.interactive.backgroundBrandContrastPressed, Slider, theme.kallisto.space.space250, Input, Switch, $variant === 'default' ? css(["background-color:", ";"], theme.kallisto.color.background.interactive.backgroundTertiaryPressed) : '', $variant === 'white' ? css(["border-color:", ";"], theme.kallisto.color.border.interactive.borderNeutralPressed) : '', Slider, theme.kallisto.space.space250) : '', Input, Slider, Input, Slider, Switch, $disabled ? theme.kallisto.color.background.static.backgroundDisabled : theme.kallisto.color.background.interactive.backgroundBrandContrastDefault);
});
var LabelText = /*#__PURE__*/styled.span.withConfig({
  displayName: "Switchstyles__LabelText",
  componentId: "sc-1ym8u79-6"
})(["margin-", ":calc(", " + 3px);color:", ";text-align:", ";"], function (_ref12) {
  var $ltr = _ref12.$ltr;
  return $ltr ? 'right' : 'left';
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.kallisto.space.space100;
}, function (_ref14) {
  var theme = _ref14.theme,
    $disabled = _ref14.$disabled;
  return $disabled ? theme.kallisto.color.text.static.textDisabled : 'inherit';
}, function (_ref15) {
  var $ltr = _ref15.$ltr;
  return $ltr ? 'left' : 'right';
});
var VisuallyHidden = /*#__PURE__*/styled.span.withConfig({
  displayName: "Switchstyles__VisuallyHidden",
  componentId: "sc-1ym8u79-7"
})(["clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;"]);
export var SwitchStyles = {
  Wrapper: Wrapper,
  SwitchWrapper: SwitchWrapper,
  Switch: Switch,
  SliderSpinner: SliderSpinnerStyled,
  Slider: Slider,
  Input: Input,
  LabelText: LabelText,
  VisuallyHidden: VisuallyHidden
};